import React from "react";
import Chart from "react-apexcharts";
import { chartTimeFormat } from "../../../Js/TimeAndDate";

const BarChart = (props) => {
  let trainerReportData = props.barData;
  let seriesMetaData = props.seriesMetaData;
  let labelData = [];
  let allData = [];

  for (let i = 0; i < trainerReportData.length; i++) {
    labelData.push(trainerReportData[i][props.labelField]);
    for (let j = 0; j < seriesMetaData.length; j++) {
      if (allData[j]) {
        allData[j].push(trainerReportData[i][seriesMetaData[j]["field"]]);
      } else {
        allData[j] = [trainerReportData[i][seriesMetaData[j]["field"]]];
      }
    }
  }

  let chartSeries = [];
  let xs = {
    xaxis: {
      categories: labelData,
    },
  };

  let xs2 = {
    stacked: false,
    events: {
      click: (event, chartContext, opts) => {
        if (opts && opts.dataPointIndex > -1) {
          props.click(opts.dataPointIndex);
        }
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  };
  xs.chart = xs2;
  xs.plotOptions = {
    bar: {
      borderRadius: 0,
      columnWidth: props.columnWidth ? props.columnWidth : "25%",
      horizontal: props.isHorizontal ? props.isHorizontal : false,
    },
  };
  xs.dataLabels = {
    style: {
      fontSize: "0.8vw",
      colors: ["#304758"],
    },
  };

  let ys = { title: { text: "" } };
  xs.yaxis = ys;

  let chartOptions = xs;

  for (let i = 0; i < seriesMetaData.length; i++) {
    chartSeries.push({
      name: seriesMetaData[i].name,
      data: allData[i],
    });
  }

  return (
    <Chart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      width={props.chartWidth ? props.chartWidth : 380}
      height={props.chartHeight ? props.chartHeight : "auto"}
    />
  );
};
export default BarChart;
